import { useEffect, useState } from 'react';
import MainFrameLeftSection from './mainFrameLeftSection';
import MainFrameRightSection from './mainFrameRightSection';
import MainFrame from './mainFrame';
import styles from './mainPage.module.css';
import usePageTitle from '../../hooks/title.hook';
import { useSearchBarContext } from '../../store/searchBar.store';
import { Folder } from '../../services/http/folder.api';
import FolderPermissionsSection from './folderPermissionsSection';
import useEffectOnce from '../../hooks/useEffectOnce.hook';
import { useCreateLogApi } from '../../hooks/api/log.hook';
import { LogControlName, LogFormName } from '../../utils/log.utils';

/**
 * 文書一覧メインページ
 */
function Component() {
  usePageTitle('文書一覧');
  // states
  const [selectedFolder, setSelectedFolder] = useState<Folder | null>(null);
  const [changingFolderPermissions, setChangingFolderPermissions] = useState(false);
  const [documentFolderChanged, setDocumentFolderChanged] = useState(0);
  const [updateFolderList, setUpdateFolderList] = useState(0);

  const { request: createLog } = useCreateLogApi();

  // hooks
  const searchBarContext = useSearchBarContext();

  useEffect(() => {
    if (selectedFolder?.id) {
      setChangingFolderPermissions(false);
    }
  }, [selectedFolder]);

  useEffect(() => () => {
    searchBarContext.setIsSearching(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!changingFolderPermissions) {
      searchBarContext.enable();
    } else {
      searchBarContext.disable();
    }

    return () => {
      searchBarContext.disable();
    };
  }, [changingFolderPermissions]);

  useEffectOnce(() => {
    createLog(LogFormName.Main, LogControlName.Show);
  });

  const folder = searchBarContext.isSearching ? null : selectedFolder;

  return (
    <div>
      <MainFrame
        borderBox
        body={(
          <div className={styles.mainFrame}>
            <div className={styles.mainSections}>
              <MainFrameLeftSection
                onDocumentFolderChanged={() => setDocumentFolderChanged((prev) => prev + 1)}
                folder={folder}
                onSelectFolder={setSelectedFolder}
                isChangingFolderPermissions={changingFolderPermissions}
                updateFolderList={updateFolderList}
              />
              {!changingFolderPermissions && (
              <MainFrameRightSection
                documentFolderChanged={documentFolderChanged}
                folder={folder}
                onChangingFolderPermissions={() => setChangingFolderPermissions(true)}
              />
              )}
              {changingFolderPermissions && (
              <FolderPermissionsSection
                folder={folder}
                onCancel={() => setChangingFolderPermissions(false)}
                updateFolderList={() => setUpdateFolderList((prev) => prev + 1)}
              />
              )}
            </div>
          </div>
        )}
      />
    </div>
  );
}

export default Component;
